/*
 ######     #######   ##    ##   ########   
##    ##   ##     ##  ###   ##   ##         
##         ##     ##  ####  ##   ##         
##         ##     ##  ## ## ##   ######     
##         ##     ##  ##  ####   ##         
##    ##   ##     ##  ##   ###   ##         
 ######     #######   ##    ##   ##         
*/

/** 
	À décommenter et modifier pour activer un chargement entre les changements de page
	fonctions : showLoader / hideLoader à compléter
	Defaut : false
**/
// pageTransition = true;

/** 
	À décommenter et modifier pour activer le chargement des pages en ajax
	Defaut : false
	Note : les liens qui font appel à un chargement via AJAX doivent contenir l'attribut rel="address"
**/
// pageAjax = true;

/** 
	À décommenter et modifier pour changer le breakpoint activant les animations parallax
	activé par défaut à partir des tablettes (768)
**/
// parallaxBreakpoint = 768;

(function($) {

	/*
	########   ########    ######    ####  ########   ########   
	##     ##  ##         ##    ##    ##        ##    ##         
	##     ##  ##         ##          ##       ##     ##         
	########   ######      ######     ##      ##      ######     
	##   ##    ##               ##    ##     ##       ##         
	##    ##   ##         ##    ##    ##    ##        ##         
	##     ##  ########    ######    ####  ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/

	/* Fonctions exécutées à chaque resize */
	var resizeHandler = function() {
		$(window).trigger('scroll');
		initScrollAnimations();
		resizeParallax();

		if( $(window).width() >= 768 ){
			$('.page-container').css('margin-bottom', $('.footer').height() );
		}else{
			$('.page-container').css('margin-bottom', 0 );
		}
		
		/* Autres fonctions jouées au resize */
		// resizeSlider();
		// resizeNav();
	};

	
	/*
	 ######     ######    ########    #######   ##         ##         
	##    ##   ##    ##   ##     ##  ##     ##  ##         ##         
	##         ##         ##     ##  ##     ##  ##         ##         
	 ######    ##         ########   ##     ##  ##         ##         
	      ##   ##         ##   ##    ##     ##  ##         ##         
	##    ##   ##    ##   ##    ##   ##     ##  ##         ##         
	 ######     ######    ##     ##   #######   ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/
	/* Fonctions exécutées au scroll */
	var scrollHandler = function() {
		var scrollTop = $(window).scrollTop();
		
		// /* EXEMPLE */
		// if (scrollTop > 380) {
		// 	$('.header').addClass('prestuck');
		// }
		// else {
		// 	$('.header').removeClass('prestuck');
		// }
	};

	/*
	##          #######      ###     ########   ########   ########   
	##         ##     ##    ## ##    ##     ##  ##         ##     ##  
	##         ##     ##   ##   ##   ##     ##  ##         ##     ##  
	##         ##     ##  ##     ##  ##     ##  ######     ########   
	##         ##     ##  #########  ##     ##  ##         ##   ##    
	##         ##     ##  ##     ##  ##     ##  ##         ##    ##   
	########    #######   ##     ##  ########   ########   ##     ##  
	*/

	showLoader = function(url) {
		tl = new TimelineLite();
		tl.pause();
		tl.add([
			// On peut chainer les évènements TweenMax ici. Example :
			// TweenMax.fromTo( $pan2l, 0,   { opacity: 0 }, { opacity: 1, delay: 0.10 } ),
			// TweenMax.fromTo( $pan3l, 0,   { opacity: 0 }, { opacity: 1, delay: 0.20 } ),
			// TweenMax.fromTo( $logo,  0.1, { opacity: 0 }, { opacity: 1, delay: 0.20 } )
		]);
		tl.call(function() {
			$(window).scrollTop(0);
			if ( pageAjax ){
				// Chargement de la page via Barba
				promise.newContainerLoading.then(promise.showloader.bind(promise));
			} else {
				// A la fin de l'anim, on redirige vers la nouvelle URLs
				window.location.href = url;
			}
		});
		tl.play();
	};

	var hideLoader = function() {
		// On lance l'animation de révélation de la page
		tl = new TimelineLite();
		tl.pause();
		tl.call(function() {
			initScrollAnimations();
		});
		tl.add([
			// On peut chainer les évènements TweenMax ici. Example :
			// TweenMax.fromTo( $pan1, 0.4, { x: '0' }, { x: '100%', delay: 0 } ),
			// TweenMax.fromTo( $pan2, 0.4, { x: '0' }, { x: '100%', delay: 0.15 } ),
			// TweenMax.fromTo( $logo, 0.2, { opacity: 1 }, { opacity: 0, delay: 0  } )
		], [], this, 1);	
		tl.play();
	};

	/*	Ajout d'un loader sur le chargement initial d’une page 
		Uniquement si la fonction de transition de page est active 
	*/
	if ( pageTransition ) {
		$('body').imagesLoaded( { background: true })
		.always( function(instance) {
			hideLoader();
		});
	}

	/*
	####  ##    ##   ####  ########   
	 ##   ###   ##    ##      ##      
	 ##   ####  ##    ##      ##      
	 ##   ## ## ##    ##      ##      
	 ##   ##  ####    ##      ##      
	 ##   ##   ###    ##      ##      
	####  ##    ##   ####     ##      
	*/

	pageInit = function() {

		// Déclaration des évènements
		$(window).on('resize orientationchange', addEndEvent);
		$(window).on('resizeEnd', resizeHandler);
		$(window).on('scroll', scrollHandler);
		$('body').on('reveal', '.sr', scrollRevealHandler);
		
		$(window).trigger('resize'); // Joue la fonction resizeHandler()
		formLoader();                // Affiche un 'cache' à la validation d’un form CF7

		/* Autres scripts qui doivent être initialisés */
		// slider.init();
		$('.data-mh').matchHeight();

		// Local smooth scroll sur les liens vers des ancres
		if ($('.localscroll').length > 0) {
			$('.localscroll').localScroll( {
				hash: true
			});
			$.localScroll.hash();
		}

		// Fitvids = video embed responsive
		if ($('.fitvids').length > 0) {
			$('.fitvids').fitVids();
		}

		$(document).click(function(){
			if( $("body").hasClass('nav--open') )
		 		$("body").removeClass('nav--open');
		});

		$('.header-toggle').unbind('click').on('click', function(e){
			$('body').toggleClass('nav--open');
			e.stopPropagation();
		});

		$('[data-link]').unbind('click').on('click', function(e){
			elCliked = $(this).find('a');
			Barba.Pjax.goTo($(this).data('link'));
		});

	};

	// Initialisation de toutes les fonctions utiles au chargement de la page
	pageInit();

})(jQuery);
